import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractSecurityStorage, ConfigurationService, OidcSecurityService } from 'angular-auth-oidc-client';
import { filter, switchMap, take } from 'rxjs';

@Component({
  selector: 'app-callback',
  template: '<div class="d-flex justify-content-center align-items-center" style="height: 100vh">Signing in...</div>',
})
export class CallbackComponent implements OnInit {
  constructor(
    private router: Router,
    private oidcSecurityService: OidcSecurityService,
    private configurationService: ConfigurationService,
    private storage: AbstractSecurityStorage
  ) {}

  ngOnInit(): void {
    this.oidcSecurityService.isAuthenticated$
      .pipe(
        filter(({ isAuthenticated }) => isAuthenticated),
        take(1),
        switchMap(() => this.configurationService.getOpenIDConfiguration()),
        take(1)
      )
      .subscribe(config => {
        const configId = config?.configId;
        const raw = configId ? this.storage.read(configId) : null;
        const stored = raw ? (JSON.parse(raw) as Record<string, unknown>) : {};
        const redirectUrl = stored['redirect'] as string | undefined;
        if (redirectUrl && configId) {
          delete stored['redirect'];
          this.storage.write(configId, JSON.stringify(stored));
          this.router.navigateByUrl(redirectUrl);
        } else {
          this.router.navigateByUrl('/');
        }
      });
  }
}
